import xhttp from 'src/utils/xhttp'

const arrangement = {
    // 部署配置
    get(params) {
        return xhttp.get('/api/dev/private/deploy/config', { params })
    },
    getAll(params) {
        return xhttp.get('/api/dev/private/deploy/config_all', { params })
    },
    add(params) {
        return xhttp.post('/api/dev/private/deploy/config', params)
    },
    edit(params) {
        return xhttp.put(`/api/dev/private/deploy/config/${params.id}`, params)
    },
    delete(params) {
        return xhttp.delete(`/api/dev/private/deploy/config/${params.deployConfigId}`, { params })
    },
    // 部署关联配置
    getRelation(params) {
        return xhttp.get('/api/dev/private/deploy/relation', { params })
    },
    addRelation(params) {
        return xhttp.post('/api/dev/private/deploy/relation', params)
    },
    editRelation(params) {
        return xhttp.put(`/api/dev/private/deploy/relation/${params.id}`, params)
    },
    deleteRelation(params) {
        return xhttp.delete(`/api/dev/private/deploy/relation/${params.id}`, { params })
    },
    // 发布管理
    getPublishStatus(params) {
        return xhttp.get('/api/dev/private/release/publish_status', { params })
    },
    publishArrangemnt(params) {
        return xhttp.post('/api/dev/private/release/publish', params)
    },
    getArrangementHistoryListTotal(params) {
        return xhttp.get('/api/dev/private/release/publish', { params })
    },
    getArrangementHistoryListSingle(params) {
        return xhttp.get(`/api/dev/private/release/detail`, { params })
    },
    getArrangementHistoryDetail(params) {
        const { publishDetailId, ...rest } = params
        return xhttp.get(`/api/dev/private/release/detail_log/${publishDetailId}`, { params: rest })
    }
}

export default arrangement
